import React from "react"
import { Link } from "gatsby"
import overviewIcon from "../../images/icons/building.svg"
import amenitiesIcon from "../../images/icons/leaf.svg"
import plansIcon from "../../images/icons/door.svg"
import blogIcon from "../../images/icons/blog.svg"
import interiorsIcon from "../../images/icons/sofa.svg"

import "./footer-menu.sass"

const isPartiallyActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent ? { className: "footer-nav-active" } : null
}

const FooterMenu = props => (
  <div className="footer-menu">
    <nav>
      <Link to="/" activeClassName="footer-nav-active">
        <img src={overviewIcon} alt="overview" />
        overview
      </Link>
      <Link to="/amenities/" activeClassName="footer-nav-active">
        <img src={amenitiesIcon} alt="amenities" />
        amenities
      </Link>
      <Link to="/floorplans/" activeClassName="footer-nav-active">
        <img src={plansIcon} alt="floorplans" />
        floorplans
      </Link>
      <Link to="/blog/" getProps={isPartiallyActive} {...props}>
        <img src={blogIcon} alt="view" />
        news
      </Link>
      <Link to="/interiors/" activeClassName="footer-nav-active">
        <img src={interiorsIcon} alt="interiors" />
        interiors
      </Link>
    </nav>
  </div>
)

export default FooterMenu
